import { GetAppliancesQuery, ProductSpecCategory } from '@/gql/graphql';

export type ApplianceFromList =
  GetAppliancesQuery['appliances']['items'][number];

export const CATEGORY_BY_SLUG: Record<string, ProductSpecCategory> = {
  'heat-pump': 'HEAT_PUMP',
  cylinder: 'CYLINDER',
  'solar-panel': 'SOLAR_PANEL',
  inverter: 'INVERTER',
  battery: 'BATTERY',
};

export const NOUN: Partial<Record<ProductSpecCategory, string>> = {
  HEAT_PUMP: 'heat pump',
  CYLINDER: 'cylinder',
  SOLAR_PANEL: 'solar panel',
  INVERTER: 'inverter',
  BATTERY: 'battery',
};
